import { useEffect, useState } from "react";
import {
  BoxButtons,
  Box,
  BoxFields,
  CancelButton,
  PrimaryButton,
  StyledLabel,
  Title,
  WrapperTotal,
} from "./styles";

import { IConfiguration } from "../../../../../@types/configuration.type";
import { Modal, TextField } from "../../../../../ui";

interface ModalFormLGProps {
  configurations: IConfiguration[];
  open: boolean;
  handleClose: () => void;
  handleSave: (token: string, user: string, password: string, url: string, environment: string) => void;
}


export const ModalFormLG = ({
  configurations,
  open,
  handleClose,
  handleSave
}: ModalFormLGProps) => {
  const [token, setToken] = useState<string>("");
  const [user, setUser] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [url, setUrl] = useState<string>("");
  const [environment, setEnvironment] = useState<string>("");

  useEffect(() => {
    const lgConfigurationToken = configurations.find(x => x.key === "CONFIGURATION_LG_GUIDTENENT")
    const lgConfigurationUser = configurations.find(x => x.key === "CONFIGURATION_LG_USER")
    const lgConfigurationPassword = configurations.find(x => x.key === "CONFIGURATION_LG_PASSWORD")
    const lgConfigurationUrl = configurations.find(x => x.key === "CONFIGURATION_LG_URL")
    const lgConfigurationEnvironment = configurations.find(x => x.key === "CONFIGURATION_LG_ENVIRONMENT")

    setToken(lgConfigurationToken?.value ?? "");
    setUser(lgConfigurationUser?.value ?? "");
    setPassword(lgConfigurationPassword?.value ?? "");
    setUrl(lgConfigurationUrl?.value ?? "");
    setEnvironment(lgConfigurationEnvironment?.value ?? "");
  }, [open]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <WrapperTotal>
          <button title="Fechar" onClick={() => handleClose()}>
            X
          </button>
          <Title>Conectar com o LG</Title>
          <Box>
            <StyledLabel>GuidTenant da API do LG</StyledLabel>
            <BoxFields>
              <TextField
                id="token"
                label="Token"
                value={token}
                onChange={(e) => {
                  setToken(e.target.value);
              }}
              />
            </BoxFields>
          </Box>
          <Box>
            <StyledLabel>Usuario do LG</StyledLabel>
            <BoxFields>
              <TextField
                id="user"
                label="user"
                value={user}
                onChange={(e) => {
                  setUser(e.target.value);
              }}
              />
            </BoxFields>
          </Box>

          <Box>
            <StyledLabel>Senha do LG</StyledLabel>
            <BoxFields>
              <TextField
                type="password"
                id="password"
                label="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
              }}
              />
            </BoxFields>
          </Box>

          <Box>
            <StyledLabel>Url do LG</StyledLabel>
            <BoxFields>
              <TextField
                id="url"
                label="url"
                value={url}
                onChange={(e) => {
                  setUrl(e.target.value);
              }}
              />
            </BoxFields>
          </Box>

          <Box>
            <StyledLabel>Ambiente do LG</StyledLabel>
            <BoxFields>
              <TextField
                id="ambiente"
                label="ambiente"
                value={environment}
                onChange={(e) => {
                  setEnvironment(e.target.value);
              }}
              />
            </BoxFields>
          </Box>

          <BoxButtons>
            <CancelButton onClick={() => handleClose()} type="button">
              Cancelar
            </CancelButton>
            <PrimaryButton onClick={() => handleSave(token, user, password, url, environment)}>Salvar</PrimaryButton>
          </BoxButtons>
        </WrapperTotal>
      </Modal>
    </>
  );
};
